module.exports = __webpack_public_path__ + "static/media/noavatar.39f4f5c8.png";